import {action, observable} from 'mobx';
import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import {ClockEvent} from 'main/stores/time_tracking';

class TimeClockState {
  store = new DomainStore();

  @observable clockInEvent = null;
  @observable errors = {};
  @observable projectId;
  @observable note;
  @observable collectEmployeeLocation;

  receiveProps({onClockEvent, collectEmployeeLocation}) {
    this.onClockEvent = onClockEvent;
    this.collectEmployeeLocation = collectEmployeeLocation;
  }

  @action async load() {
    await this.store._compose([
      endpoints.TIME_TRACKING.CURRENT_CLOCK_IN
    ]);

    const clockEvent = this.store._getSingle(types.TIME_TRACKING.CLOCK_EVENT);

    if (clockEvent) {
      this.clockInEvent = new ClockEvent(clockEvent);
      this.projectId = clockEvent.projectId;
      this.note = clockEvent.note;
    }
  }

  @action updateProjectId(id) {
    this.projectId = id;
  }

  @action updateNote(note) {
    this.note = note;
  }

  @action async clockIn() {
    const clockEvent = new ClockEvent({
      location: { timezone: Intl.DateTimeFormat().resolvedOptions().timeZone },
      note: this.note,
      projectId: this.projectId?.toString()
    });

    if (this.collectEmployeeLocation) {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      }).catch(() => null);

      if (!position || position.coords.accuracy >= 250) return this.openLocationErrorModal();

      clockEvent.location.latitude = position.coords.latitude;
      clockEvent.location.longitude = position.coords.longitude;
      clockEvent.location.accuracy = position.coords.accuracy;
    }

    const {model, errors} = await this.store.post(
      endpoints.TIME_TRACKING.CLOCK_IN,
      types.TIME_TRACKING.CLOCK_EVENT,
      clockEvent
    );

    this.errors = errors;

    if (model) {
      this.clockInEvent = new ClockEvent(model);
      this.onClockEvent();
    }
  }

  @action async clockOut() {
    const clockEvent = new ClockEvent();

    if (this.collectEmployeeLocation) {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      }).catch(() => null);

      if (!position || position.coords.accuracy >= 250) return this.openLocationErrorModal();

      clockEvent.location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy
      };
    }

    const {model, errors} = await this.store.post(
      endpoints.TIME_TRACKING.CLOCK_OUT,
      types.TIME_TRACKING.CLOCK_EVENT,
      clockEvent
    );

    this.errors = errors;

    if (model) {
      this.clockInEvent = null;
      this.onClockEvent();
    }
  }
}

export default TimeClockState;
